import { Link } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 pt-16 md:pt-20 flex items-center justify-center px-4">
        <div className="text-center py-20 max-w-md">
          <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-background-100 text-primary-500 text-3xl">
            <i className="ri-emotion-sad-line" aria-hidden="true"></i>
          </span>
          <p className="mt-6 font-heading text-5xl font-bold text-background-300">404</p>
          <h1 className="mt-3 font-heading text-2xl font-bold text-foreground-950">
            这页瓜还没长出来
          </h1>
          <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
            你找的页面可能已经被整理或移动了。回首页或者去新瓜速递，那里一定有今天的新鲜事。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-home-4-line" aria-hidden="true"></i>
              回到首页
            </Link>
            <Link
              to="/news"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-800 text-sm font-medium whitespace-nowrap hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer"
            >
              去新瓜速递
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}